var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LineChart',{ref:"distributionLineChart",attrs:{"chart-data":_vm.chartData,"options":_vm.lineChartOptions,"width":_vm.Width,"height":_vm.Height}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }